// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2ameS","buttons":"SendReceipts_buttons__3yZ56","email":"SendReceipts_email__LQq2a","bookApptTitle":"SendReceipts_bookApptTitle__KhDNp"};